import { ReactElement, useRef, useState } from 'react';
import { useMessage, useMessageGetter } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { Row, Tab, Tabs } from '@op/opds.opux';
import { ReactComponent as PortfolioImage } from '../../images/OP_symbolikuvitus_128_007.svg';
import parseMsgContent from '../../util/parseMsgContent';
import CourseHeader from '../CourseHeader';
import CourseContent from '../CourseContent';
import TaskOne from './TaskOne';
import TaskTwo from './TaskTwo';
import CourseComplete from '../CourseComplete';
import ReturnToTop from '../ReturnToTop';
import TextComponent from '../TextComponent';

const Course3 = (): ReactElement => {
  const getCourseTexts = useMessageGetter('course3');
  const fundContent = useMessage('course3.courseContent.funds');
  const stockContent = useMessage('course3.courseContent.stocks');
  const etfContent = useMessage('course3.courseContent.etf');
  const fundIntroContent = useMessage('course3.courseContent.funds_intro');
  const stockIntroContent = useMessage('course3.courseContent.stocks_intro');
  const etfIntroContent = useMessage('course3.courseContent.etf_intro');

  const parsedFunds = parseMsgContent(fundContent);
  const parsedStocks = parseMsgContent(stockContent);
  const parsedEtf = parseMsgContent(etfContent);
  const parsedFundsIntro = parseMsgContent(fundIntroContent);
  const parsedStocksIntro = parseMsgContent(stockIntroContent);
  const parsedEtfIntro = parseMsgContent(etfIntroContent);

  const targetRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState<{ [key: string]: number }>({
    first_div: 0,
  });

  const handleTabChange = (divId: string, index: number): void => {
    setActiveTab((prev) => ({
      ...prev,
      [divId]: index,
    }));
  };

  return (
    <div
      style={{ marginBottom: space.default }}
      className="opds-styles-v1-elements-text "
    >
      <CourseHeader
        courseTitleId="course3.title"
        courseHeaderText="how_to_start"
        Image={PortfolioImage}
        courseNumber={3}
      />

      <div style={{ textAlign: 'center', paddingBottom: space.default }}>
        <TextComponent messageId="course3.introduction" twoColumns={false} />
      </div>

      <div ref={targetRef}>
        <Tabs
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '1 0 0',
          }}
          active={activeTab.first_div}
          onChange={(event, index) => handleTabChange('first_div', index)}
        >
          <Tab
            id="first_tab"
            className="investoracademy-course-tab"
            label={getCourseTexts('instruments.funds')}
          >
            <Row style={{ margin: 0 }}>
              <CourseContent content={parsedFundsIntro} headingAs="h2" />
              <CourseContent content={parsedFunds} />
            </Row>
          </Tab>
          <Tab
            id="second_tab"
            className="investoracademy-course-tab"
            label={getCourseTexts('instruments.stocks')}
          >
            <Row style={{ margin: 0 }}>
              <CourseContent content={parsedStocksIntro} headingAs="h2" />
              <CourseContent content={parsedStocks} />
            </Row>
          </Tab>

          <Tab
            id="third_tab"
            className="investoracademy-course-tab"
            label={getCourseTexts('instruments.etf')}
          >
            <CourseContent content={parsedEtfIntro} headingAs="h2" />
            <CourseContent content={parsedEtf} />
          </Tab>
        </Tabs>
      </div>

      <ReturnToTop
        msgId="return_to_tabs"
        targetRef={targetRef}
        index={activeTab.first_div}
      />
      <TaskOne />
      <TaskTwo />
      <CourseComplete messageId="course3.recap" />
    </div>
  );
};

export default Course3;
